import { getImageProps } from 'next/image'
import shots from '@/public/console/shots/shots.json'

// A picture of the real console (npm run console:shots), in the visitor's scheme: the dark one
// when the system is dark, as the rest of the site. Re-run the script after a console redesign
// and every picture follows; nothing here draws the console.

export type ShotName = keyof typeof shots.shots

// The capture's time on every URL: the image optimiser caches by URL, so without it a re-capture
// kept showing the old picture until its cache was cleared.
const version = `?v=${Date.parse(shots.takenUtc)}`

export default function ConsoleShot({ name, alt, sizes = '(max-width: 1000px) 100vw, 1200px', className }: {
  name: ShotName
  alt: string
  sizes?: string
  className?: string
}) {
  const { width, height } = shots.shots[name]
  // Quality 90: at the default 75 the compression smears the console's small text.
  const common = { alt, width, height, sizes, quality: 90 }
  const { props: { srcSet: dark } } = getImageProps({ ...common, src: `/console/shots/${name}-dark.png${version}` })
  const { props: light } = getImageProps({ ...common, src: `/console/shots/${name}-light.png${version}` })
  return (
    <picture className={className}>
      <source media="(prefers-color-scheme: dark)" srcSet={dark} />
      <img {...light} alt={alt} style={{ display: 'block', width: '100%', height: 'auto' }} />
    </picture>
  )
}
